(() => {
  'use strict';
  const theme=window.Shopify?.theme;
  if(!theme?.id||!['unpublished','development','demo'].includes(String(theme.role)))return;
  if(window.TMPreviewLinksV58){window.TMPreviewLinksV58.scan(document);return;}
  const themeId=String(theme.id),localeRoot=new URL(window.Shopify?.routes?.root||'/',location.origin).pathname.replace(/\/$/,'');
  const localeCodes=(document.querySelector('script[data-tm-preview-locales]')?.getAttribute('data-tm-preview-locales')||'').toLowerCase().split(',').filter(Boolean);
  function decorate(link){
    const href=link.getAttribute('href');
    if(!href||href[0]==='#'||link.hasAttribute('download')||link.hasAttribute('data-no-theme-preview'))return;
    let target;
    try{target=new URL(href,location.href);}catch(error){return;}
    if(target.origin!==location.origin||!/^https?:$/.test(target.protocol))return;
    let pathname=target.pathname;
    if(localeRoot&&pathname.startsWith(localeRoot+'/'))pathname=pathname.slice(localeRoot.length);
    if(pathname===localeRoot)pathname='/';
    // Recognize published languages, including Shopify market subfolders.
    const parts=pathname.split('/'),prefix=parts[1]?.toLowerCase();
    if(localeCodes.some(code=>prefix===code||prefix.startsWith(code+'-')))pathname='/'+parts.slice(2).join('/');
    const family=pathname.split('/')[1];
    if(pathname!=='/'&&!['products','pages','collections','blogs','policies','search','cart'].includes(family))return;
    if(family==='cart'&&!/^\/cart\/?$/.test(pathname))return;
    if(family==='cart'&&['checkout','return_to','redirect'].some(key=>target.searchParams.has(key)))return;
    if(/\.(?:js|json|svg|png|jpe?g|webp|pdf|zip)$/i.test(pathname))return;
    const previewIds=target.searchParams.getAll('preview_theme_id');
    if(previewIds.length===1&&previewIds[0]===themeId)return;
    target.searchParams.set('preview_theme_id',themeId);
    link.setAttribute('href',target.pathname+target.search+target.hash);
  }
  function scan(scope){scope.querySelectorAll('a[href]').forEach(decorate);}
  function onNavigate(event){
    const path=event.composedPath?.()||[event.target];
    const link=path.find(node=>node?.tagName==='A')||event.target.closest?.('a[href]');
    if(link)decorate(link);
  }
  window.TMPreviewLinksV58={scan};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
  for(const event of ['click','auxclick','contextmenu'])document.addEventListener(event,onNavigate,{capture:true,passive:true});
  document.addEventListener('shopify:section:load',event=>scan(event.target));
})();
